import { render, staticRenderFns } from "./suppliesFormOutsideAdd.vue?vue&type=template&id=db51395c"
import script from "./suppliesFormOutsideAdd.vue?vue&type=script&lang=js"
export * from "./suppliesFormOutsideAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports